// extracted by css-extract-rspack-plugin
export default {"root":"root-MIHvNo","svg":"svg-bGm0S3","svgdark":"svgdark-G_H0MZ"};